import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=08b63104&"
import script from "./passengers.vue?vue&type=script&lang=ts&"
export * from "./passengers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports